import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import { IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const CancelDialogActions = ({doCancelBooking, setOpen}) => {
  return([
    <Button key={'cancel_book_action_1'} variant="outlined" onClick={()=>{setOpen(false)}}startIcon={<ArrowBackIosNewIcon />}>Back </Button>,
    <Button key={'cancel_book_action_2'} variant="contained" onClick={doCancelBooking} color="error" endIcon={<DoDisturbIcon/>}>Cancel Booking </Button>
  ])
}

const CancelDialogBody = ({charge, setCharge}) => {

  return (
    <div style={{ width: '100%' }}>
      <TextField id="cancelCharge" label="Cancellation Charge" value={charge} onChange={(e)=>{setCharge(e.target.value)}} inputProps={{ inputMode: 'numeric' }}/>
    </div>
  )
}
const CancelDialog = ({charge, setCharge, open, setOpen, doCancelBooking}) => {

  return (
    <Dialog
        onClose={()=>{setOpen(false)}}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={()=>{setOpen(false)}}>Cancel Booking</BootstrapDialogTitle>
        <DialogContent dividers>
          <CancelDialogBody charge={charge} setCharge={setCharge}/>
        </DialogContent>
        <DialogActions>
          <CancelDialogActions doCancelBooking={doCancelBooking} setOpen={setOpen}/>
        </DialogActions>
      </Dialog>
  )
  /*return (
    <DialogWindow title={'Cancel Booking'} Body={<Body/>} Actions={Actions} open={open} setOpen={setOpen}  maxWidth={'sm'}/>
  )*/
}


export default CancelDialog